export const keyfeatures = {
  QSleeve: [
    {
      id: 1,
      title: "Quantum-Safe Remote Access",
      description:
        "Provides secure access to organizational networks for remote employees, ensuring data confidentiality over untrusted networks. Quantum-resistant cryptographic techniques protect sensitive information while supporting smooth and secure workGows for distributed teams.",
      link: "#",
    },
    {
      id: 2,
      title: "QSleeve Easy Server Management",
      description:
        "Provides a simplified, centralized interface to monitor and administer multiple servers, enabling rapid deployment and consistent policy enforcement across the infrastructure. Features include bulk actions for updates and maintenance, role-based access control for delegated administration, and health checks with alerting to ensure servers remain secure and available.",
      link: "#",
    },
    {
      id: 3,
      title:
        "Site-to-Site Connectivity &amp; High Availability Mode of Operations with QSleeve",
      description:
        "Enables quantum-secure, encrypted communication between geographically distributed sites, ensuring the privacy and integrity of data exchanges. This feature supports secure inter-office communication, making it ideal for organizations with multiple locations.",
      link: "#",
    },
    {
      id: 4,
      title: "Client Connection Controls",
      description:
        "Offers highly configurable client connection policies to enforce security and operational requirements for remote users. controls include per-client session limits, bandwidth and protocol restrictions, and certificate-based authentication options, and automatic client disconnect if inactive.",
      link: "#",
    },
    {
      id: 5,
      title: "Load Balancing",
      description:
        "Distributes network traffic efficiently across multiple servers to improve performance and reliability. This feature balances workloads, prevents bottlenecks, and ensures stable, secure data Gow, enabling enterprise networks to handle growing demands with ease.",
      link: "#",
    },
    {
      id: 6,
      title: "Quantum-Safe Connection for Cloud Infrastructure",
      description:
        "Secures data transmission between on-premises systems and cloud environments, protecting information from interception or tampering. Quantum-resistant encryption safeguards sensitive workloads in the cloud while ensuring compliance with security standards and data protection regulations.",
      link: "#",
    },
    {
      id: 7,
      title: "Quantum-Safe Hybrid Infrastructure",
      description:
        "Delivers a unified security framework for hybrid IT environments, enabling secure communication across on-premises, cloud, and edge systems. Quantum-resistant encryption ensures consistent data protection, making it suitable for organizations managing diverse and adaptable infrastructures.",
      link: "#",
    },
  ],
  ECDL: [
    {
      id: 0,
      title: "Quantum Sensing",
      description:
        "Hyperfine spectroscopy of atoms and molecules, Laser cooling and trapping of atoms and ions",
    },
    {
      id: 1,
      title: "Quantum Communication ",
      description:
        "Narrow entangled-photon sources (N-EPS) and N-EPS-based Quantum Key Distribution (QKD) experiments",
    },
    {
      id: 2,
      title: "Quantum Computing ",

      description: "Laser cooling and trapping of atoms and ions",
    },
  ],
  QuantumBiosensor: [
    {
      id: 0,
      title: "Cardiology ",
      description:
        "Magnetocardiography (MCG) for early detection of arrhythmias,ischemia, and fetal heart monitoring",
    },
    {
      id: 1,
      title: "Neurology",
      description:
        "Magnetoencephalography (MEG) for mapping epilepsy, neurodegenerative diseases (e.g., Alzheimer&#39;s, Parkinson&#39;s), stroke recovery, and cognitive disorders",
    },
    {
      id: 2,
      title: "Ophthalmology ",
      description:
        "Retinal magnetic field measurements for vision-related pathologies",
    },
    {
      id: 3,
      title: "Neuromuscular and beyond  ",
      description:
        "Magnetomyography (MMG) for muscle and nerve function assessment",
    },
  ],
  Checq: [
    {
      id: 0,
      title: "Easy Dashboard ",
      description:
        "Stay organised and in control with a clean, intuitive dashboard. Access all historical scans, track trends, and maintain a detailed audit trail of your organisation’s cryptographic health. Designed for simplicity, the dashboard allows teams to quickly review insights, compare past results, and make informed decisions.",
    },
    {
      id: 1,
      title: "Web Scanning",
      description:
        "Ensures the quantum-readiness of your public-facing assets. Our web scanning feature continuously evaluates the quantum security posture of your website and the external websites or services you depend on. It helps you monitor configuration health, enforce secure practices, and maintain confidence in every digital connection your organisation interacts with.",
    },
    {
      id: 2,
      title: "Scanning Code and Networks",
      description:
        "Identify hidden cryptographic risks across your ecosystem. Our solution performs deep code scanning and network scanning to uncover the cryptographic algorithms, libraries, and cipher suites currently in use. This information helps organisations plan, modernise, and continuously monitor their cryptographic infrastructure as they transition to quantum-safe standards.",
    },
    {
      id: 3,
      title: "Detailed Report Generation ",
      description:
        "Gain complete visibility into your organisation’s cryptographic landscape. Our platform delivers in-depth reports featuring a comprehensive Cryptographic Bill of Materials (CBOM) for your entire inventory, along with a clear assessment of your overall security posture. Each report includes prioritised remediation steps to support an effective and structured post-quantum migration strategy.",
    },
    {
      id: 4,
      title: "AI-Enabled Analysis",
      description:
        "Our built-in AI engine enhances the platform across the board by assisting in analysis, remediation planning, and report generation. It transforms complex scan data into actionable insights, helping your organisation prioritise risks, accelerate decision-making, and achieve a more efficient transition to quantum-safe security.",
    },
  ],
};

export const servicesData = [
   
        {
            id: 1,
            title: "Quantum Secure Migration",
            description: "QSleeve ensures data security against quantum attacks by using post-quantum cryptography (PQC). PQC employs advanced mathematical algorithms resistant to quantum decryption methods, safeguarding sensitive information in the future quantum era."
        },
        {
            id: 2,
            title: "Business strategy",
            description: "Our quantum-safe communication is designed for effortless integration into existing infrastructure. It upgrades security to protect against quantum threats with minimal changes, ensuring smooth, uninterrupted operations."
        },
        {
            id: 3,
            title: "Technology consulting",
            description: "QSleeve simplifies network and client management. It provides straightforward administration and monitoring of connected devices."
        },
        {
            id: 4,
            title: "Quantum + AI Integration",
            description: "QSleeve offers high customizability to meet user-specific requirements. Tailor security protocols and configurations to match your unique needs, ensuring optimal protection against quantum threats."
        },];



export const servicestackdata = {
  QSleeve: [
    {
      id: 0,
      name: "Enterprise security:",

      content:
        "Ensures comprehensive protection across enterprise networks and systems.",
    },
    {
      id: 1,
      name: "Server protection:",

      content:
        "Safeguards servers from emerging quantum threats with quantum-safe encryption.",
    },
    {
      id: 2,
      name: "Network security",

      content:
        "Enhances network security by securing communication channels against quantum attacks.",
    },
    {
      id: 3,
      name: "Cloud security",

      content:
        "Provides quantum-safe encryption for cloud environments, ensuring data integrity and confidentiality.",
    },
    {
      id: 4,
      name: "Web security",

      content:
        "Secures web applications and user interactions with post-quantum cryptography.",
    },
    {
      id: 5,
      name: "Secure transactions",

      content:
        "Ensures the security of digital transactions with robust quantum-safe algorithms.",
    },
  ],
};


   export const ecdlData = [
     {
       id: 0,
       name: "Quantum Sensing",
       content:
         "Hyperfine spectroscopy of atoms and molecules, Laser cooling and trapping of atoms and ions",
     },
     {
       id: 1,
       name: "Quantum Communication ",
       content:
         "Narrow entangled-photon sources (N-EPS) and N-EPS-based Quantum Key Distribution (QKD) experiments",
     },
     {
       id: 2,
       name: "Quantum Computing ",

       content: "Laser cooling and trapping of atoms and ions",
     },
   
   ];
          


